import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import '../css/testimonials.css';
import { Autoplay } from 'swiper/modules';

export default function Testimonials({ data }) {
  return (
    <section className="bm-testimonials">
      <div className="container-fluid">
        <h2 className="text-center default-box-title  mb-2">
          Những chia sẻ của cựu sinh viên
        </h2>
        <p className="text-center">Chuyển hóa lãnh đạo - Kiến tạo tương lai</p>

        <article>
          <Swiper
            loop={true}
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
              reverseDirection: true,
            }}
            speed={5000}
            allowTouchMove={false}
            spaceBetween={20}
            grabCursor={true}
            modules={[Autoplay]}
            slidesPerView={2}
            breakpoints={{
              0: {
                slidesPerView: 2,
              },
              576: {
                slidesPerView: 3,
              },
              768: {
                slidesPerView: 4,
              },
              992: {
                slidesPerView: 5,
              },
              1200: {
                slidesPerView: 6,
              },
            }}
          >
            {data.map((item, i) => (
              <SwiperSlide key={i}>
                <div className="item-wrapper">
                  <div style={{ width: '100%' }}>
                    <img
                      src={item.imageUrl}
                      alt={item.title}
                      className="testimonial-img"
                    />
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <div style={{ margin: '2rem 0' }} />

          <Swiper
            loop={true}
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
            }}
            speed={5000}
            allowTouchMove={false}
            spaceBetween={20}
            grabCursor={true}
            modules={[Autoplay]}
            slidesPerView={2}
            breakpoints={{
              0: {
                slidesPerView: 2,
              },
              576: {
                slidesPerView: 3,
              },
              768: {
                slidesPerView: 4,
              },
              992: {
                slidesPerView: 5,
              },
              1200: {
                slidesPerView: 6,
              },
            }}
          >
            {data.map((item, i) => (
              <SwiperSlide key={i}>
                <div className="item-wrapper">
                  <img
                    src={item.imageUrl}
                    alt={item.title}
                    className="testimonial-img"
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </article>

        <div className="text-center my-3">
          <a
            href="/cau-chuyen-thanh-cong-business-master"
            className="btn btn-view-all"
          >
            <i className="fa-solid fa-list-ul mx-1"></i>
            Xem tất cả
          </a>
        </div>
      </div>
    </section>
  );
}
